import { Button } from '@tractian/ui'
import { useTranslation } from 'react-i18next'

import { resetMatrixOverride, saveMatrixOverride } from '@/features/matrix/domain/matrix-override'
import type { MatrixFormState } from '@/features/matrix/hooks/use-matrix-form'

export type MatrixActionsProps = {
  /** Edit state, owned by useMatrixForm — the same source the form fields read. */
  state: MatrixFormState
}

/**
 * Save / Reset for the matrix override. Save validates through `state.submit`,
 * so an off-allowlist URL surfaces its field error instead of reaching storage.
 * Shared by the /matrix page and the dev-tools modal footer.
 */
export function MatrixActions({ state }: MatrixActionsProps) {
  const { t } = useTranslation('matrix')

  return (
    <>
      <Button
        type="button"
        variant="outline"
        onClick={() => resetMatrixOverride()}
        data-testid="matrix-reset"
      >
        {t('actions.resetToDefaults')}
      </Button>
      <Button
        type="button"
        onClick={() => state.submit(saveMatrixOverride)}
        data-testid="matrix-save"
      >
        {t('actions.save')}
      </Button>
    </>
  )
}
